/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Uebungsleiterprolernfoerderung4Inputs */

const de__field_uebungsleiterprolernfoerderung4 = /** @type {(inputs: _Field_Uebungsleiterprolernfoerderung4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LKK Gesamt-Leko-Bedarf (Startwert)`)
};

/**

* @param {_Field_Uebungsleiterprolernfoerderung4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_uebungsleiterprolernfoerderung4 = /** @type {((inputs?: _Field_Uebungsleiterprolernfoerderung4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Uebungsleiterprolernfoerderung4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_uebungsleiterprolernfoerderung4(inputs)
});
export { _field_uebungsleiterprolernfoerderung4 as "_field_uebungsLeiterProLernFoerderung" }